<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15 2C16.5977 2 17.9037 3.24892 17.9949 4.82373L18 5V8C18 8.26039 17.8985 8.50867 17.7202 8.6938L17.6247 8.78087L13.6 12L17.6247 15.2191C17.8619 15.4089 18 15.6962 18 16V19C18 20.6569 16.6569 22 15 22H9C7.34315 22 6 20.6569 6 19V16C6 15.6962 6.13809 15.4089 6.3753 15.2191L10.399 12L6.3753 8.78087C6.17198 8.61821 6.04148 8.38388 6.00834 8.12895L6 8V5C6 3.40232 7.24892 2.09634 8.82373 2.00509L9 2H15ZM12 13.281L8 16.48V19C8 19.5523 8.44772 20 9 20H15L15.1166 19.9933C15.614 19.9355 16 19.5128 16 19V16.481L12 13.281ZM9 4H15L15.1166 4.00673L15.2293 4.02641C15.6711 4.13005 16 4.52661 16 5V7.519L12 10.719L8 7.52V5L8.00673 4.88338C8.06449 4.38604 8.48716 4 9 4Z"
    fill="currentColor"
  />
</svg>
